import { InformationIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';

interface Props {
    text?: string;
};

/** Placeholder shown where a plan list or a plan's job table has no rows. */
function EmptyState({ text = 'No data.' }: Props) {
    return (
        <div className={styles.empty}>
            <InformationIcon />
            <span>{text}</span>
        </div>
    );
};

export default EmptyState;
